import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["forInput", "headingOnly", "className", "hasSuccess", "dataset", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import { useMemo } from 'react';
import { marked } from 'marked';
import styles from './styles.module.scss';
import parentStyles from '../styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const Label = _ref => {
  let {
    forInput,
    headingOnly,
    className = '',
    hasSuccess = false,
    dataset,
    onClick
  } = _ref,
      contentProps = _objectWithoutProperties(_ref, _excluded);

  const classNames = clsx(styles.container, className || ''); // For form fields like radio buttons
  // a compatable label heading  UI is needed,
  // however div's avoid nesting labels, which
  // wrap each individual <input>

  if (headingOnly) {
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({
      className: classNames
    }, dataset && _objectSpread({}, dataset)), onClick && {
      onClick
    }), {}, {
      children: /*#__PURE__*/_jsx(LabelContent, _objectSpread({
        hasSuccess: hasSuccess
      }, contentProps))
    }));
  } // Regular label


  return /*#__PURE__*/_jsx("label", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, dataset && _objectSpread({}, dataset)), forInput && {
    htmlFor: forInput
  }), onClick && {
    onClick
  }), {}, {
    className: classNames,
    children: /*#__PURE__*/_jsx(LabelContent, _objectSpread({
      hasSuccess: hasSuccess
    }, contentProps))
  }));
};

export default Label;

const LabelContent = _ref2 => {
  let {
    text,
    icon,
    variant = '',
    caption,
    children,
    errorMessage,
    hasSuccess,
    rightAdornment
  } = _ref2;
  const htmlContent = useMemo(() => caption ? marked.parseInline(caption) : '', [caption]);
  const variants = useMemo(() => variant.split(',').map(variantName => styles[`heading--${variantName.trim()}`]).filter(Boolean), [variant]);
  const hasHeader = text || icon || rightAdornment;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [hasHeader ? /*#__PURE__*/_jsxs("div", {
      className: styles.header,
      children: [text || icon ? /*#__PURE__*/_jsxs("p", {
        className: clsx(styles.heading, ...variants),
        children: [text, ' ', icon ? /*#__PURE__*/_jsx("span", {
          className: styles.heading__icon,
          children: icon
        }) : '']
      }) : /*#__PURE__*/_jsx(_Fragment, {}), rightAdornment || /*#__PURE__*/_jsx(_Fragment, {})]
    }) : /*#__PURE__*/_jsx(_Fragment, {}), children, errorMessage && /*#__PURE__*/_jsx("p", {
      className: parentStyles.errorMessage,
      children: errorMessage
    }), caption && /*#__PURE__*/_jsx("p", {
      className: clsx(styles.caption, hasSuccess && styles['caption--hasSuccess']),
      dangerouslySetInnerHTML: {
        __html: htmlContent
      }
    })]
  });
};